var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckBlack({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "check",
    d: "M6.453,2A4.453,4.453,0,0,0,2,6.453v6.094A4.453,4.453,0,0,0,6.453,17h6.094A4.453,4.453,0,0,0,17,12.547V6.453A4.453,4.453,0,0,0,12.547,2ZM3.406,6.453A3.047,3.047,0,0,1,6.453,3.406h6.094a3.047,3.047,0,0,1,3.047,3.047v6.094a3.047,3.047,0,0,1-3.047,3.047H6.453a3.047,3.047,0,0,1-3.047-3.047Zm9.455,1.868a.7.7,0,0,0-.946-1.041L8.65,10.249,7.424,9.134a.7.7,0,1,0-.946,1.041l1.7,1.545a.7.7,0,0,0,.946,0Z",
    transform: "translate(-2 -2)",
    fill: "#888",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckBlack);
export default __webpack_public_path__ + "static/media/check-black.c3a503f02e958b79ca422b4354884a13.svg";
export { ForwardRef as ReactComponent };